// German dictionary. Same keys as en.ts. Machine-assisted, reviewed for tokens.

export const de: Record<string, string> = {
  "dawn.era0": "Die weite Steppe",
  "dawn.era1": "Die Khagane",
  "dawn.era2": "Stein und Reich",
  "dawn.era3": "Die Republik",
  "dawn.era4": "Jenseits des Himmels",
  "dawn.lore0": "Über den ersten Zelten spannt sich der ewige blaue Himmel.",
  "dawn.lore1": "Das Wolfsbanner erhebt sich zum Himmel.",
  "dawn.lore2": "Von Manzikert führt dein Weg ins Herz Anatoliens.",
  "dawn.lore3": "Deine Kuppeln antworten dem Himmel.",
  "dawn.lore4": "Aus der Asche erhebt sich ein Volk.",
  "dawn.lore5": "Der Himmel wird vom Dach zum Tor.",
  "dawn.lore6": "Unter fremden Himmeln schlägst du dein Zelt auf.",
  "dawn.lore7": "Du bist nun der Hirte der Sterne.",
  "dawn.lore8": "Die Milchstraße wird dein Wanderweg.",
  "dawn.lore9": "Du liest das erste Licht des Universums.",
  "dawn.lore10": "Der letzte Schleier hebt sich.",
  "dawn.lore11": "Der Kreis schließt sich; der erste Morgen wartet.",
  'common.continue': 'Weiter',
  'common.skip': 'Überspringen',
  'common.next': 'Weiter',
  'common.finish': 'Fertig',
  'common.close': 'Schließen',
  'common.back': 'Zurück',
  'common.send': 'Senden',
  'common.begin': 'Beginnen',

  'hud.spoils': 'Beute',
  'hud.skillPts': 'Talentpunkte',
  'hud.cosmic': 'Kosmisch',
  'hud.population': 'Bevölkerung',
  'hud.buildings': 'Gebäude',
  'hud.autoOn': 'Auto-Sammeln: an',
  'hud.autoProgress': 'Auto-Sammeln: {have}/{need} Sammler',
  'hud.nextBuilding': 'Nächstes Gebäude',
  'hud.needPop': 'zuerst Bevölkerung vergrößern',
  'hud.ascend': 'Aufsteigen',

  'wave.next': 'Nächste Welle',
  'wave.waveN': 'Welle {n}',
  'wave.bossN': 'Boss-Welle ({n})',
  'wave.incoming': 'Welle naht',
  'wave.bossIncoming': 'Boss naht',
  'wave.now': 'JETZT',
  'wave.yourPower': 'Deine Stärke',
  'wave.enemyPower': 'Feindmacht',
  'wave.conquer': '{planet}-Eroberung: Ära {goal}',
  'wave.conquered': '{planet} erobert',

  // Ära-Tor (der Boss, der jeden Ära-Aufstieg bewacht)
  'gate.progress': '{boss} sammelt sich am Tor: {pct}%',
  'gate.atGate': '{boss} am Tor!',
  'gate.final': 'Letzte Ära erreicht',
  'gate.summonTitle': 'Das Tor öffnet sich',
  'gate.summonSub': '{boss} sammelt sich am Tor. Besiege ihn, um ins nächste Zeitalter zu treten; bricht er durch, fällt deine Linie.',
  'gate.freeProgress': 'Nächstes Zeitalter: {pct}%',
  'gate.cleared': 'Tor durchbrochen',
  'gate.clearedSub': 'Eine neue Ära liegt vor dir',

  'banner.repelled': 'Welle abgewehrt',
  'banner.overrun': 'Dorf überrannt',
  'banner.onHorizon': '{enemy} am Horizont',
  'banner.bossApproaches': 'Der Boss marschiert auf das Tor',
  'banner.scattered': '{enemy} zerstreut',
  'banner.brokeThrough': '{enemy} durchgebrochen',

  'milestone.autoTitle': 'Auto-Sammeln freigeschaltet',
  'milestone.autoSub': 'Dein Volk sammelt jetzt selbst Ressourcen.',
  'milestone.settlementNow': 'Deine Siedlung ist nun ein {name}',
  'milestone.settlementGrows': 'Deine Siedlung wächst',

  'intro.begin': 'Beginnen',
  'intro.tagline': 'Vom Staub der Steppe zur Herrschaft über den Himmel.',
  'intro.story':
    'Unter dem ewig blauen Himmel: eine Handvoll Zelte in der Steppe. Du herrschst nicht über das Volk, du bist der Wille des Himmels, der es leitet. Steige Zeitalter um Zeitalter auf, kehre stärker aus deiner Asche zurück, wenn du fällst, und öffne dich den Sternen, bis der Himmel keine Decke mehr ist, sondern eine Heimat zum Zurückkehren.',

  'news.title': 'Neuigkeiten',
  'news.sub': 'Was sich seit deinem letzten Besuch geändert hat (v{version})',
  'news.all': 'Alle Updates',

  'tut.s1.title': 'Willkommen',
  'tut.s1.text':
    'Das ist dein Volk. Tippe dorthin, wo du sammeln willst; der gelbe Kreis bleibt dort und bearbeitet die umliegenden Bäume, Felsen und Erze. Tippe woanders hin, um ihn zu versetzen (am PC folgt er der Maus).',
  'tut.s2.title': 'Ressourcen',
  'tut.s2.text': 'Holz, Stein, Erz und Wissen, das du sammelst, häuft sich hier an.',
  'tut.s3.title': 'Deine Siedlung',
  'tut.s3.text':
    'Dein Volk baut mit diesen Ressourcen von selbst. Bevölkerung, Gebäudezahl und was das nächste Gebäude braucht, siehst du hier.',
  'tut.s4.title': 'Wellen',
  'tut.s4.text':
    'In Abständen kommen Plünderer. Ist deine Stärke groß genug, schlägst du sie zurück; bricht eine Welle durch, fällt deine Linie und du erhebst dich mit Weisheit neu.',
  'tut.s5.title': 'Der Rest liegt bei dir',
  'tut.s5.text':
    'Jedes spätere Zeitalter wird von einem Boss am Tor bewacht: besiege ihn, um ein Artefakt zu erhalten und eine Richtung zu wählen (Wirtschaft, Heer, Wissen). 🔬 Technologie, 👤 Konto und Feedback. Viel Spaß!',

  'account.title': 'Konto',
  'account.feedbackLabel': 'Feedback',
  'account.feedbackPlaceholder': 'Was denkst du? Bug, Idee, Gefühl... alles hilft.',
  'account.dangerZone': 'Gefahrenzone',
  'account.resetBtn': 'Allen Fortschritt löschen (neu starten)',
  'account.resetConfirm':
    'Bist du sicher? Talentbaum, Kosmisch, Planeten und der aktuelle Lauf werden gelöscht. Das lässt sich nicht rückgängig machen.',
  'account.resetYes': 'Ja, alles löschen',
  'account.resetNo': 'Abbrechen',
  'account.replayTutorial': 'Anleitung erneut anzeigen',
  'account.logout': 'Abmelden',
  'account.signIn': 'Anmelden und Fortschritt sichern',
  'account.guest': 'Du spielst als Gast. Dein Fortschritt liegt nur auf diesem Gerät.',
  'account.language': 'Sprache',
  'account.supportLabel': 'Unterstützung',
  'account.supportBtn': 'Dieses Spiel unterstützen',

  'nudge.early': "Wie läuft's? Eine kurze Notiz hilft sehr 🙏",
  'nudge.later': 'So weit hast du es geschafft! Magst du teilen, was du denkst?',
  'nudge.cta': 'Feedback',

  'login.title': 'Anmelden',
  'login.sub':
    'Melde dich an, um deinen Fortschritt geräteübergreifend zu sichern. Du kannst das überspringen und dich jederzeit über 👤 anmelden.',
  'login.guest': 'Jetzt spielen, später anmelden',
  'login.emailPlaceholder': 'deine@email.com',
  'login.sendCode': 'Code senden',
  'login.codePlaceholder': '6-stelliger Code',
  'login.verify': 'Bestätigen',
  'login.sending': 'Senden...',
  'login.codeSent': 'Ein Code wurde an deine E-Mail gesendet.',
  'login.verifying': 'Wird geprüft...',
  'login.errGeneric': 'Etwas ist schiefgelaufen, bitte versuche es erneut.',
  'login.errCode': 'Der Code ist falsch oder abgelaufen.',

  'death.title': 'Deine Linie ist gefallen',
  'death.lede':
    'Du hast Zeitalter {age} erreicht. Gehaltene Wellen: {waves}. Gib deine schwer erkämpfte Weisheit aus und erhebe dich erneut.',
  'death.bossLede':
    'Der Ära-Boss {boss} hat dein Tor in Zeitalter {age} durchbrochen. Gehaltene Wellen: {waves}. Steck deine neuen Punkte in Verteidigung, bevor du ihm erneut gegenübertrittst.',
  'death.wavesHeld': 'Gehaltene Wellen',
  'death.ageReached': 'Erreichtes Zeitalter',
  'death.skillPoints': 'Talentpunkte',
  'death.restart': 'Erneut erheben',
  'death.ascendTo': '🚀 Zu {planet} aufsteigen (+{gain} kosmisch)',

  'offline.title': 'Während du weg warst',
  'offline.sub': 'Dein Volk hat {time} weitergearbeitet.',
  'offline.collect': 'Einsammeln',

  'cards.title': 'Ein Zeitalter wendet sich',
  'cards.sub': 'Wähle eine Richtung für dein Volk.',

  'cat.economy': 'Wirtschaft',
  'cat.military': 'Militär',
  'cat.knowledge': 'Wissen',
  'lab.active': 'Aktiv',
  'lab.cost': 'Kosten',
  'lab.title': 'Labor',
  'lab.spoilsWord': 'Beute',
  'lab.techs': 'Technologien (Beute)',
  'lab.artifacts': 'Artefakte (mit Ressourcen aktivieren)',
  'lab.artifactsHint': 'Besiege den Ära-Boss an jedem Zeitalter-Tor, um sein Artefakt zu erhalten.',

  'err.invalid_email': 'Gib eine gültige E-Mail ein.',
  'err.send_failed': 'Code konnte nicht gesendet werden, versuche es gleich erneut.',
  'err.missing_fields': 'Fehlende Angaben.',
  'err.need_code': 'Fordere zuerst einen Code an.',
  'err.too_many_attempts': 'Zu viele Versuche. Fordere einen neuen Code an.',
  'err.code_expired': 'Der Code ist abgelaufen.',
  'err.code_wrong': 'Der Code ist falsch.',
  'err.invalid_save': 'Ungültiger Spielstand.',
  'err.empty_feedback': 'Das Feedback ist leer.',
  'err.auth_required': 'Anmeldung erforderlich.',
  'account.feedbackEmpty': 'Schreib zuerst etwas.',
  'account.feedbackThanks': 'Danke, gesendet!',
  'account.feedbackError': 'Senden fehlgeschlagen, versuche es erneut.',
  'account.btnTitle': 'Konto & Feedback',
  'milestone.ageDawns': 'Zeitalter {n} bricht an',
  'milestone.synergy': 'Synergie: {name}',
  'milestone.artifactFound': 'Artefakt gefunden: {name}',
  'milestone.artifactHint': 'Aktiviere es mit Ressourcen',
  'milestone.artifactActive': '{name} aktiviert',
  'milestone.conquerReady': '{planet} gehört dir',
  'milestone.conquerReadySub': 'Steige auf, sichere kosmische Macht und nimm die nächste Welt',
  'milestone.ascended': 'Zu {planet} aufgestiegen',
  'milestone.ascendedSub': '+{gain} kosmische Macht',
  'combat.dodge': 'Ausgewichen!',
  'combat.miss': 'Verfehlt',
  'combat.block': 'Block',
  'lab.owned': 'Erworben',
  'lab.activate': 'Aktivieren',
  'ui.soundTitle': 'Ton an/aus',
  'login.signedIn': 'angemeldet',
  'login.offline': 'offline',
  'skill.lv': 'St {lvl}/{max}',
  'skill.max': 'MAX',
  'offline.nothing': 'In deiner Abwesenheit wurde nichts gesammelt.',
  'death.firstLede': 'Das ist nicht das Ende, es ist der Kreislauf: jeder Fall zahlt Weisheit. Gib sie aus und erhebe dich stärker.',
  'death.spendHint': 'Gib deine Punkte aus und erhebe dich erneut.',
  'err.google_failed': 'Google-Anmeldung fehlgeschlagen.',
  'login.or': 'oder',

  // Wave skip + voluntary retirement (v0.10)
  'wave.sendNow': 'Welle jetzt schicken',
  'retire.btn': 'Zivilisation beenden',
  'retire.lockedAt': 'Ab Zeitalter {n} verfügbar',
  'retire.confirm': 'Zum Beenden erneut tippen',
  'death.retireLede': 'Du hast diese Linie aus freien Stücken beendet: Zeitalter {age}, {waves} Wellen gehalten. Gib die Weisheit aus und gründe eine stärkere.',
};
